import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import axios from 'axios';
import { parseApiPayload } from './utils/apiResponse';

axios.interceptors.request.use((config) => {
  const url = String(config.url || '');
  const exempt =
    url.includes('/partner/login')
    || url.includes('/partner/submit-application')
    || url.includes('/partner/check-join-email')
    || url.includes('/partner/set-password');
  if (!url.includes('/partner/') || exempt) {
    return config;
  }
  try {
    const raw = localStorage.getItem('partner_auth');
    const p = raw ? JSON.parse(raw) : null;
    if (p?.token) {
      const headers = config.headers || {};
      headers.Authorization = `Bearer ${p.token}`;
      config.headers = headers;
    }
  } catch (_) {
    /* ignore */
  }
  return config;
});
axios.interceptors.response.use((response) => {
  if (response?.data != null) {
    response.data = parseApiPayload(response.data);
  }
  return response;
});
axios.defaults.transformResponse = [
  (data) => parseApiPayload(data),
];
import { getImageUrl } from './utils/utils'; // Import the helper
import ToastPlugin from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-bootstrap.css';
// Import Bootstrap and custom CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './assets/css/utility.css';
import './assets/css/responsive.css';
import VueLazyload from 'vue3-lazyload';
import websiteNameMixin from './mixins/websiteName';
import { readWebsiteNameFromStorage } from './utils/currentWebsite';
import { readCountryNameFromStorage } from './utils/currentCountry';
// Set the base URL for all Axios requests for local
// axios.defaults.baseURL = 'http://lushgroom-backend.test/api';
// Set the base URL for all Axios requests for live
axios.defaults.baseURL = 'https://admin.lushgroom.com/api';
// Set the base URL for all Axios requests for local

const websiteName = readWebsiteNameFromStorage();
if (!localStorage.getItem('website_name')) localStorage.setItem('website_name', websiteName);
// Create the Vue app instance
const app = createApp(App);
app.mixin(websiteNameMixin);
// Register Axios as a global property
app.config.globalProperties.$axios = axios;
// Register the helper function globally
app.config.globalProperties.$getImageUrl = getImageUrl;
// Legacy alias — prefer this.activeWebsiteName in components (reactive when website changes)
app.config.globalProperties.$websiteName = websiteName;
// Selected country display name (used to replace hardcoded "Dubai" in UI)
app.config.globalProperties.$countryName = readCountryNameFromStorage() || 'Dubai';
// Use the router and mount the app
app.use(ToastPlugin);
app.use(VueLazyload, {
  loading: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAusB9QpqlPYAAAAASUVORK5CYII=',
  error: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAusB9QpqlPYAAAAASUVORK5CYII='
});
// router.afterEach((to) => {
//   const canonicalUrl = window.location.origin + to.fullPath;

//   let link = document.querySelector("link[rel='canonical']");
//   if (link) {
//     link.setAttribute("href", canonicalUrl);
//   } else {
//     link = document.createElement("link");
//     link.setAttribute("rel", "canonical");
//     link.setAttribute("href", canonicalUrl);
//     document.head.appendChild(link);
//   }
// });
router.afterEach((to) => {
  const canonicalUrl = window.location.origin + to.fullPath;

  // Set/update canonical tag
  let canonicalLink = document.querySelector("link[rel='canonical']");
  if (canonicalLink) {
    canonicalLink.setAttribute("href", canonicalUrl);
  } else {
    canonicalLink = document.createElement("link");
    canonicalLink.setAttribute("rel", "canonical");
    canonicalLink.setAttribute("href", canonicalUrl);
    document.head.appendChild(canonicalLink);
  }

  // GLOBAL noindex/nofollow (temporary)
  let robotsMeta = document.querySelector("meta[name='robots']");
  if (!robotsMeta) {
    robotsMeta = document.createElement("meta");
    robotsMeta.setAttribute("name", "robots");
    document.head.appendChild(robotsMeta);
  }
  robotsMeta.setAttribute("content", "noindex,nofollow");
});
app.use(router).mount('#app');
